import {
	SET_TIMEUUID,
	SET_TEST_STATIONS,
	CACHE_DEFAULT_TEST_STATIONS,
	CACHE_SERVER_TEST_STATIONS,
	SET_IS_LOADING,
	SET_IS_LOADED,
	SET_IS_SAVING,
	SET_ERROR_MESSAGE,
} from '../actions/testStations'

const defaultState = {selected:[]}
const testStations = (state = defaultState, action) => {
	switch (action.type) {
		case SET_TIMEUUID: {
			return {...state, timeuuid: action.payload};
		}
		case SET_TEST_STATIONS: {
			return {...state, selected:action.payload};
		}
		case CACHE_DEFAULT_TEST_STATIONS: { 
			return {...state, cachedDefaultTestStations:action.payload};
		}
		case CACHE_SERVER_TEST_STATIONS: {
			return {...state, cachedServerTestStations:action.payload};
		}
		case SET_IS_LOADING: {
			return {...state, isLoading: action.payload};
		}
		case SET_IS_LOADED: {
			return {...state, isLoaded: action.payload};
		}
		case SET_IS_SAVING: {
			return {...state, isSaving: action.payload};
		}
		case SET_ERROR_MESSAGE: {
			return {...state, errorMessage: action.payload};
		}
		default:
			return state;
	}
};

export default testStations;